import { render } from "./xsjj.vue?vue&type=template&id=59fde9c7&scoped=true&ts=true"
import script from "./xsjj.vue?vue&type=script&lang=ts"
export * from "./xsjj.vue?vue&type=script&lang=ts"

import "./xsjj.vue?vue&type=style&index=0&id=59fde9c7&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59fde9c7"]])

export default __exports__